import React from 'react'
import { Box, Grid, Typography, Card, CardMedia, Divider } from '@mui/material'
import ServicesHeader from './servicesHeader'
import './services.css'

import treeExample1 from '../_content/tree2.webp'
import treeExample2 from '../_content/tree1.webp'
import treeExample3 from '../_content/tree3.webp'

const TreeServices = () => {
  return (
    <>
      <ServicesHeader
        background={treeExample1}
        text="Tree & Shrub Services"
      />

      {/* TOP STRIP */}
      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />
      <Box className="top-strip">
        <Typography className="top-strip-text">
          Professional tree care, pruning and removal services carried out safely and efficiently across Brentwood and Essex.
        </Typography>
      </Box>
      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />

      {/* WHITE SECTION */}
      <Box className="section-wrapper">
        <Box className="section-inner">
          <Box className="section-content">

            <Typography className="section-heading" variant="h5">
              Safe, reliable tree care for every garden
            </Typography>

            <Typography className="section-subtext">
              From routine maintenance to full tree removal, we provide expert services to keep your outdoor space safe, tidy and well-maintained.
            </Typography>

            <Box className="section-divider" />

            <Grid container spacing={3} alignItems="stretch">
              {[
                {
                  title: 'Safe Tree Removal',
                  text: 'We remove trees carefully and efficiently, ensuring safety and minimal disruption to your property.',
                },
                {
                  title: 'Pruning & Maintenance',
                  text: 'Regular trimming improves the health, structure and appearance of your trees and shrubs.',
                },
                {
                  title: 'Responsible Approach',
                  text: 'We carry out all work with care, respecting your garden and the surrounding environment.',
                },
              ].map((item, i) => (
                <Grid item xs={12} md={4} key={i} sx={{ display: 'flex' }}>
                  <Box className="service-card">
                    <Box>
                      <Typography className="card-title">{item.title}</Typography>
                      <Typography className="card-text">{item.text}</Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>

          </Box>
        </Box>
      </Box>

      {/* IMAGE SECTION */}
      <Box className="image-section">
        <Typography className="image-title" variant="h5">
          Recent Projects
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {[treeExample1, treeExample2, treeExample3].map((img, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Card className="image-card">
                <CardMedia
                  component="img"
                  image={img}
                  alt={`Tree service example ${i + 1}`}
                  className="image-media"
                />
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  )
}

export default TreeServices